import { useState } from "react";
import { FaGithub } from "react-icons/fa";
import { useAuth } from "../../contexts/AuthContext";
import "./LoginPage.css";

const GITHUB_REPO_URL = "https://github.com/koiljat/selenedocs";

function LoginPage({ isDarkMode }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { signIn } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      await signIn(email, password);
    } catch (err) {
      console.error(err);
      setError(err.message || "Authentication failed");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className={`login-container ${isDarkMode ? "dark-theme" : "light-theme"}`}
    >
      {/* Background decorative elements */}
      <div className="bg-decoration decoration-1"></div>
      <div className="bg-decoration decoration-2"></div>
      <div className="bg-decoration decoration-3"></div>

      <div className="login-card">
        <div className="login-header">
          <div className="logo-container">
            <img
              src="/assets/selene-logo.png"
              alt="Selene Logo"
              className="login-logo"
            />
          </div>
          <h1>Welcome</h1>
          <p className="login-subtitle">Sign in to continue to SeleneDocs</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <div className="input-wrapper">
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
                autoComplete="email"
                disabled={isLoading}
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <div className="input-wrapper">
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                required
                autoComplete="current-password"
                disabled={isLoading}
              />
            </div>
          </div>

          {error && (
            <div className="error-message">
              <svg
                className="error-icon"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
              </svg>
              {error}
            </div>
          )}

          <button type="submit" className="login-button" disabled={isLoading}>
            {isLoading ? (
              <>
                <span className="button-spinner"></span>
                Signing in...
              </>
            ) : (
              "Sign In"
            )}
          </button>
        </form>
      </div>

      {/* Footer */}
      <div className="login-footer">
        <p>BT4101 Final Year Project</p>
        <p className="footer-small">by Chong Koil Jat</p>
        <p className="footer-small">National University of Singapore</p>
        <a
          className="footer-github-link"
          href={GITHUB_REPO_URL}
          target="_blank"
          rel="noreferrer"
        >
          <FaGithub className="footer-github-icon" />
          GitHub Repository
        </a>
      </div>
    </div>
  );
}

export default LoginPage;
